import type { ListOrgRecordingsApiArg } from '@/__generated/es-api'

export const RECORDINGS_EXPORT_LIMIT = 1000

export type RecordingsDateRange = {
  from?: string
  to?: string
}

export type RecordingFilters = Pick<ListOrgRecordingsApiArg, 'campid' | 'userid' | 'startDate' | 'endDate'>
